(ns practitest.frontend.components2.grid.save-filter-button
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [re-frame.core :as re-frame]
            [clojure.string :as str]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.components.grid.subs :as grid.subs]))

(defn save-filter-button [{:keys [grid-state on-open-modal]}]
  (let [module (:module @grid-state)
        entity-type (keyword (str/lower-case module))
        state-key (entity-type subs/index-grid-keys)
        current-view @(re-frame/subscribe [::grid.subs/current-view entity-type state-key])
        auto? (or (:auto_filter current-view) (:auto current-view))
        label (get-translation "grid.fast-filters.save-as-label" "Save as a Filter")
        button-elem
        [buttons/button
         {:tertiary? true
          :disabled? auto?
          :class "filter-save-as"
          :on-click (fn [e]
                      (dom/prevent-default e)
                      (dom/stop-propagation e)
                      (when (not auto?)
                        (mixpanel/track "Grid Actions" {"Action" "Open Save fast filter modal"})
                        (on-open-modal)))
  :icon [icons/svg-plus-lg]
  :text label}]]

  (if auto?
    [tooltip/mux-tooltip
     {}
     (get-translation "grid.fast-filters.auto-filter-tooltip" "This action is disabled for auto-filters")
     (fn [props] [:div props button-elem])]
    button-elem)))
